import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from '@angular/router'; // import router from angular router
import { from, Subject, Subscription } from "rxjs";
import { concatMap, map, takeUntil, tap } from 'rxjs/operators';
import { GlobalConstants } from "../app.component";
import { APIService } from "../common/api.component";
import { APIData } from "../common/APIData";
import { Constants } from "../common/constants";
import { ErrorData } from "../common/ErrorData";
import { SharedService } from "../common/shared.service";
import { ShareUtils } from "../common/shareutils";
import { Utils } from "../common/utils.component";
import { FileFolderItem } from "../folder/folder.component";
import { ShareLink } from "../models/sharelink";
import { ShareSettings } from "../models/sharesettin";
import { ShareSettingsDialogComponent } from "../settings/sharesettings-dialog.component";
import { DuplicateDialogComponent } from "./duplicate-dialog.component";
import { UploadDuplicateData } from "./uploadDuplicateData";
import { UploadShareData } from "./UploadShareData";
@Component({
  selector: 'app-upload',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.scss']
})
export class UploadComponent implements OnInit, OnDestroy {
  @ViewChild("shareSettingsDialog") shareSettingsDialogComponent: ShareSettingsDialogComponent;
  @ViewChild(DuplicateDialogComponent, { static: false }) duplicateDialogComponent: DuplicateDialogComponent

  enableUploadButton: boolean = false;
  duplicateFileSaveOption: string = "";
  loading: any = false
  file: any
  parentFolderId: number = 0;
  siteId: number;
  location: any;
  blnOverrideDuplicate: boolean = false;
  duplicateFileDetectionLevel: number = 0;
  duplicationchecked: boolean = false

  uploadFailMessage = Constants.UPLOAD_COMMAN_ERROR
  uploadProgress: number = -1
  uploadAnother = Constants.UPLOAD_ANOTHER
  uploadToHQ = Constants.UPLOAD_FILE_TO_HQ
  dragAndDrop = Constants.DRAG_AND_DROP
  or = Constants.OR
  browseForFile = Constants.BROWSE_FOR_FILE
  uploadFileLoc = Constants.UPLOAD_FILE_LOCATION
  shareLink = Constants.SHARE_LINK
  cancel = Constants.CANCEL
  shareLinkDesc = Constants.SHARE_LINK_DESC
  done = Constants.DONE
  share = new ShareLink();
  public SYNC_STATUS_DONE = "DONE";
  public SYNC_STATUS_INPROGRESS = "INPROGRESS";
  public SYNC_STATUS_FAIL = "FAIL";
  SYNC_STATUS_NOT_RECEIVED = "FILE_IS_NOT_RECIEVED"
  uploadStatus: string = "";
  sub: any;
  fileDetail: FileFolderItem;
  docId: number;

  type: string;
  types: string;
  locationShare: string
  id: number;
  name: string;
  size: string;
  lastmodified: string;
  shareSettings: ShareSettings;
  isShare: boolean = false;
  isDuplicate: boolean = false;

  private onDestroy$: Subject<void> = new Subject<void>();
  subscription: Subscription;
  errorMsg = { str: "" }
  routeId: string;
  chunkSize: number = Constants.CHUNK_SIZE_IN_BYTES; //190Mb
  enableChunkUpload: boolean = true;

  constructor(private shareUtils: ShareUtils, private apiService: APIService, private route: Router, private sharedSer: SharedService, private activeRoute: ActivatedRoute, private utils: Utils, private dialog: MatDialog) {
    this.subscription = sharedSer.isShare$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        isShare => {
          this.isShare = isShare;
        });
  }

  ngOnInit(): void {
    this.duplicateFileSaveOption = "";
    this.cancel = Constants.CANCEL
    this.apiService.ValidateMsTeamContextAndFatchTeamsId(this.sharedSer);
    this.apiService.setTheme();
    if (GlobalConstants.Tid == null || GlobalConstants.Tid.length == 0) {
      const urlParams = new URLSearchParams(window.location.search);
      GlobalConstants.Tid = urlParams.get('q');
    }
    if (GlobalConstants.Tid.length > 0) {
      this.AuthenticateUser();
    }
    this.getInstanceInfo();
  }

  getInstanceInfo() {
    this.apiService.getInstanceInfo()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe({
        next: (data) => {
          localStorage.setItem(Constants.COLLABORATE_VERSION, data['basicdetails']['version']);
          //this.getChunkuploadConfigurations();
          var date = new Date();
          if ((localStorage.getItem(Constants.COLLABORATE_VERSION) == "undefined"
            || this.utils.versionCompare(localStorage.getItem(Constants.COLLABORATE_VERSION), Constants.VERSION_5_7) >= 0)
            && (localStorage.getItem(Constants.API_CALL_CHUNK_UPLOAD_CONFIGURATION) == "undefined"
              || Number(localStorage.getItem(Constants.API_CALL_CHUNK_UPLOAD_CONFIGURATION)) < date.getTime())) {
            date.setHours(date.getHours() + 12)
            localStorage.setItem(Constants.API_CALL_CHUNK_UPLOAD_CONFIGURATION, date.getTime() + "");
            this.getChunkuploadConfigurations()
          }
        },
        error: (errdata) => {
          this.loading = false
          this.sharedSer.setLoading(this.loading);
          this.errorMsg.str = errdata.errorMsg
        }
      })
  }


  getChunkuploadConfigurations() {
    this.apiService.getChunkuploadConfigurations()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe({
        next: (data) => {
          var instanceproperties = data['instancedetails']['property']
          for (let item of instanceproperties) {
            if (item['alias'] === Constants.CHUNK_UPLOAD_ENABLE) {
              localStorage.setItem(Constants.CHUNK_UPLOAD_ENABLE_FLAG, item['value'] + "");
            }
            if (item['alias'] === Constants.CHUNK_CONFIG_TEXT_CHUNK_SIZE) {
              var tempChunkSize: number = item['value'];
              if (tempChunkSize > Constants.CHUNK_SIZE_MIN_MB)
                tempChunkSize = Constants.CHUNK_SIZE_MIN_MB;
              localStorage.setItem(Constants.CHUNK_CONFIG_TEXT_CHUNK_SIZE, tempChunkSize.toString());
            }
            if (item['alias'] === Constants.CHUNK_CONFIG_TEXT_CHUNK_FILE_SIZE) {
              var tempChunkFileSize: number = item['value'];
              if (tempChunkFileSize > Constants.CHUNK_SIZE_MIN_MB)
                tempChunkFileSize = Constants.CHUNK_SIZE_MIN_MB;
              localStorage.setItem(Constants.CHUNK_CONFIG_TEXT_CHUNK_FILE_SIZE, tempChunkFileSize.toString());
            }
          }
        },
        error: (errdata) => {
          this.loading = false
          this.sharedSer.setLoading(this.loading);
          this.errorMsg.str = errdata.errorMsg
        }
      });
  } l̥

  public AuthenticateUser() {
    this.loading = true
    this.apiService.authenticateUserCall()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe({
        next: (data) => {
          this.loading = false
          if (data['Key'] == "Authenticate" && data['Value'].length > 0) {
            GlobalConstants.Jwi = data['Value'];
            this.init()
          } else {
            this.sharedSer.logout();
          }
        },
        error: (err) => {
          this.loading = false
          this.utils.openConfirmationDialog({ errorData: err }, this.dialog, item => {

            this.apiService.logoutUser().subscribe(data => {
              this.sharedSer.logout()
            })

          })
        }
      });
  }

  init() {
    this.sharedSer.isUploadScreen$.next(true);
    this.file = this.sharedSer.uploadFile$.getValue() || {};
    this.activeRoute.paramMap
      .pipe(map(() => {
        this.parentFolderId = window.history.state.parentFolderId
        this.siteId = window.history.state.siteId
        this.location = window.history.state.uploadPath
        this.blnOverrideDuplicate = window.history.state.overrideDuplicate
        this.duplicateFileDetectionLevel = window.history.state.duplicateFileDetectionLevel
        this.duplicationchecked = window.history.state.duplicationchecked

      }
      )).subscribe(() => { });
    //Note: duplicateFileDetectionLevel = 1 for setting (Ask before add duplicate)
    if (this.blnOverrideDuplicate && !this.duplicationchecked && this.duplicateFileDetectionLevel == 1) {
      this.loading = true
      this.apiService.getFileDuplicates(this.file.name, this.parentFolderId)
        .pipe(takeUntil(this.onDestroy$))
        .subscribe({
          next: (duplicatefile) => {
            this.loading = false;
            if (duplicatefile != null && duplicatefile['documentduplicatelist'] != null && duplicatefile['documentduplicatelist'].length > 0) {
              this.isDuplicate = true;
              var uploadDuplicateData = new UploadDuplicateData();
              uploadDuplicateData.filename = duplicatefile['documentduplicatelist'][0]['name'];
              uploadDuplicateData.sitename = this.location;
              uploadDuplicateData.fileid = duplicatefile['documentduplicatelist'][0]['fileid'];

              uploadDuplicateData.parentFolderId = this.parentFolderId;
              uploadDuplicateData.siteId = this.siteId;
              uploadDuplicateData.uploadPath = this.location;
              uploadDuplicateData.duplicateFileDetectionLevel = this.duplicateFileDetectionLevel;
              this.sharedSer.updateDuplicateData$.next(uploadDuplicateData)

            } else {
              this.uploadFileFlow()
            }
          },
          error: (err) => {
            this.loading = false
            this.errorMsg.str = err.errorMsg
          }
        });
    } else {
      this.uploadFileFlow()
    }
  }

  public uploadFileFlow() {
    if (this.file != null && this.file != undefined && this.parentFolderId != null && this.parentFolderId != undefined && this.parentFolderId > 0) {
      var filesList: any[] = [];
      filesList.push(this.file)
      filesList[0].progress = 0
      this.prepareFilesList(filesList)
      this.uploadFile()
    }
  }
  public ngOnDestroy(): void {
    this.subscription.remove(this.subscription);
    this.subscription.unsubscribe();
    this.onDestroy$.next();
    this.sharedSer.isUploadScreen$.next(false);

  }

  public getFileIcon() {
    var ext = this.file?.name.split('.').pop();
    return this.utils.getFileIcon(ext);
  }

  gatherAPIData(sitefolderID: any, sitename: any, siteId): any {
    var apiData = new APIData()
    apiData.parentFolderId = sitefolderID
    var arr = []
    arr.push(sitename)
    arr.push(siteId)
    apiData.additionalData = arr
    return apiData
  }

  setEnableChunkUpload(blnFlage) {
    this.enableChunkUpload = blnFlage;
  }

  uploadFile() {
    this.enableChunkUpload = Boolean(localStorage.getItem(Constants.CHUNK_UPLOAD_ENABLE_FLAG));
    var tempChunkFileSize: number = Number(localStorage.getItem(Constants.CHUNK_CONFIG_TEXT_CHUNK_FILE_SIZE));
    if (tempChunkFileSize != undefined)
      tempChunkFileSize = Constants.CHUNK_SIZE_MIN_MB;
    tempChunkFileSize = 1024 * 1024 * tempChunkFileSize;
    if (this.enableChunkUpload && this.file.size > tempChunkFileSize) {
      var tempChunkSize: number = Number(localStorage.getItem(Constants.CHUNK_CONFIG_TEXT_CHUNK_SIZE));
      if (tempChunkSize != undefined && tempChunkSize > 0)
        this.chunkSize = 1024 * 1024 * tempChunkSize;
      this.uploadFileInChunk();
    }
    else
      this.uploadFullFile();
  }

  public uploadFullFile() {
    this.sub = this.apiService.uploadFile(this.parentFolderId, this.file, this.siteId, this.file.name, this.blnOverrideDuplicate)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe({
        next: (data) => {
          this.uploadFileSubscribe(data);
        },
        error: (err) => {
          this.handleError(err);
        }
      });
  }

  public uploadFileInChunk() {
    return new Promise<any>(async (resolve, reject) => {
      const sendChunkPromises = new Array<any>();

      var endSize = 0;
      var totalSize = this.file.size;
      var contentRange;
      var routeId = '';

      for (let offset = 0; offset < totalSize; offset += this.chunkSize) {
        endSize = offset + this.chunkSize;
        if (endSize > totalSize)
          endSize = totalSize;

        var chunk = this.file.slice(offset, endSize);
        contentRange = 'bytes ' + offset + '-' + (endSize - 1) + '/' + totalSize;
        sendChunkPromises.push({ chunk: chunk, contentRange: contentRange });
      }

      from(sendChunkPromises).pipe(
        concatMap(u => this.apiService.uploadChunk(this.parentFolderId, this.siteId, u.chunk, this.file.name, this.blnOverrideDuplicate, u.contentRange, routeId)
          .pipe(tap(res => {
            var RouteId = res['RouteId'];
            if (RouteId != undefined && RouteId.length > 0)
              routeId = RouteId;
          })))
      )
        .subscribe({
          next: (data) => {
            this.uploadFileSubscribe(data);
          },
          error: (err) => {
            this.handleError(err);
          }
        });
    });
  }

  public uploadFileSubscribe(data) {
    var fileid;
    if (data.hasOwnProperty('documentsWithUpdatedVersion')) {
      data = data['documentsWithUpdatedVersion'];
      fileid = data[0]['fileid'];
    }
    else
      fileid = data['fileid'];
    if (fileid != undefined && fileid.length > 0) {
      this.sharedSer.uploadFile$.next(null)
      this.files[0].progress = 100
      this.sharedSer.isUploadFlow$.next(false)
      this.docId = fileid
      this.uploadStatus = this.SYNC_STATUS_DONE
      this.cancel = Constants.DONE
    }
    else {
      this.uploadStatus = this.SYNC_STATUS_FAIL
    }
  }

  @ViewChild("fileDropRef", { static: false }) fileDropEl: ElementRef;
  files: any[] = [];
  router: any;

  /**
   * on file drop handler
   */
  onFileDropped($event) {
    this.fileBrowseHandler($event)
  }

  /**
   * handle file from browsing
   */
  fileBrowseHandler(files) {

    const fileLocal = files[0];
    if (fileLocal.size > 0 && fileLocal.size < 200 * 1024 * 1024) {
      this.file = fileLocal
      this.sharedSer.uploadFile$.next(this.file);
      this.sharedSer.isUploadFlow$.next(true);
      this.route.navigate(['login'])
    } else {
      var errorData = new ErrorData()
      if (fileLocal.size > 200 * 1024 * 1024) {
        errorData.errorMsg = Constants.FILE_LENGTH_GREATER
      } else {
        errorData.errorMsg = Constants.FILE_LENGTH_ZERO
      }
      this.errorMsg.str = errorData.errorMsg

    }
  }

  clearErrorMsg() {
    this.errorMsg.str = ""
  }

  uploadAgain() {
    this.clearErrorMsg()
    this.parentFolderId = undefined
    this.files = []
    this.uploadStatus = ""
    this.sharedSer.uploadFile$.next(null);
    this.sharedSer.isUploadFlow$.next(false);
  }


  handleShareItem() {
    this.clearErrorMsg()
    this.getFileInfo(this.docId)
  }


  /**
   * Convert Files list to normal array list
   * @param files (Files List)
   */
  prepareFilesList(files: Array<any>) {
    for (const item of files) {
      item.progress = 0;
      this.files.push(item);
    }
  }

  /**
   * format bytes
   * @param bytes (File size in bytes)
   * @param decimals (Decimals point)
   */
  formatBytes(bytes, decimals = 2) {
    return this.utils.formatBytes(bytes, decimals)
  }

  getFileInfo(docId: any) {
    this.loading = true
    this.sub = this.apiService.getFileInfo(docId)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe({
        next: (data) => {
          this.loading = false
          this.fileDetail = data;
          var fileFolderobj = {
            filefoldername: this.fileDetail.name,
            types: "file",
            fileType: this.fileDetail.type,
            contentId: this.fileDetail.id,
            locations: this.fileDetail.location,
            fileSize: this.fileDetail.size,
            lastmodified: this.fileDetail.modifieddate,
          }

          if (localStorage.getItem(Constants.SHOW_DIALOG_STORAGE) === 'true' || localStorage.getItem(Constants.SHOW_DIALOG_STORAGE) === 'undefined' || localStorage.getItem(Constants.SHOW_DIALOG_STORAGE) == null) {
            this.utils.openDialog(this.apiService, this.dialog, fileFolderobj, this.shareUtils, this.share, false, this.sharedSer, this.errorMsg, false);
          } else {
            if (localStorage.getItem(Constants.LINKEXPIRES_STORAGE) != null) {
              this.shareUtils.generateSharelink(fileFolderobj, this.share, this.apiService, null, this.utils, this.dialog, this.shareUtils, this.sharedSer, this.errorMsg, false)
            } else {
              this.utils.getSettings(this.apiService, this.dialog, false, fileFolderobj, this.shareUtils, this.share, false, this.sharedSer, this.errorMsg, false)
            }
          }
        },
        error: (err) => {
          this.loading = false
          this.errorMsg.str = err.errorMsg
        }
      });
  }

  closeUploadView() {
    this.apiService.submitTask(null);
  }
  setDataForShareDialog(data: any, share: ShareSettings, types: any, filefoldername: any) {
    var uploadShareData = new UploadShareData()
    uploadShareData.type = data.type;
    uploadShareData.types = types;
    uploadShareData.id = data.id;
    uploadShareData.location = data.location;
    uploadShareData.name = filefoldername;
    uploadShareData.size = data.size
    uploadShareData.lastmodified = data.modifieddate
    uploadShareData.shareSettings = share
    this.sharedSer.updateShareData$.next(uploadShareData)
  }


  handleError(err: any) {
    if (err.refCode == 432 || err.refCode == 433 || err.refCode == 434) {
      this.loading = true
      this.apiService.getSite(this.siteId)
        .subscribe({
          next: (data) => {
            this.loading = false
            err.sites = this.utils.getSiteTemp(data, this.siteId)
            err.apiData = this.gatherAPIData(err.sites.sitefolderID, err.sites.sitename, err.sites.id)
            this.utils.openErrorDialog({ errorData: err }, this.dialog, item => {
              if (item == true) {
                this.uploadFile()
              } else {
                this.uploadStatus = this.SYNC_STATUS_FAIL
              }
            })
          },
          error: (errdatas) => {
            this.loading = false
            if (err.errorMsg != Constants.COMMON_ERR_MSG) {
              this.uploadFailMessage = err.errorMsg
            }
            this.uploadStatus = this.SYNC_STATUS_FAIL
          }
        })

    } else {
      this.loading = false
      if (err.errorMsg === Constants.CHUNK_NOT_ALLOWED) {
        this.getChunkuploadConfigurations()
        this.uploadFullFile()
      }
      else if (err.errorMsg != Constants.COMMON_ERR_MSG && err.errorMsg != undefined) {
        this.uploadFailMessage = err.errorMsg
      }
      this.uploadStatus = this.SYNC_STATUS_FAIL
    }
  }


  
  //Call on duplicate file save option change (call from child - duplicate component)
  duplicateFileSaveEvent(event: any): void {
    this.duplicateFileSaveOption = event;
    this.enableUploadButton = true;
  }

  //upload duplicate file event
  UploadDuplicateFile() {
    //Call duplicate component method
    this.duplicateDialogComponent.duplicateFileSave(this.duplicateFileSaveOption);
  }

}





